import type { SVGProps } from "react";
export interface BandageIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function BandageIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: BandageIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M13.644 1.8a4.124 4.124 0 0 1 5.518.282l2.756 2.756.282.313a4.124 4.124 0 0 1 0 5.205l-.282.313-4.077 4.075-.045.052-.052.045-2.903 2.903-.045.052-.052.045-4.075 4.077a4.124 4.124 0 0 1-5.518.282l-.313-.282-2.756-2.756a4.123 4.123 0 0 1 0-5.83l4.078-4.08.044-.048.049-.044L9.16 6.253l.044-.049.049-.044 4.08-4.078.311-.283ZM3.673 14.922a1.873 1.873 0 0 0 0 2.648l2.755 2.756.144.129c.735.599 1.82.556 2.505-.13l3.33-3.329-5.404-5.404zm4.92-4.92 5.404 5.403 1.41-1.409-5.404-5.404zm8.978-6.33a1.873 1.873 0 0 0-2.506-.127l-.142.127-3.33 3.33 5.404 5.403 3.33-3.33a1.87 1.87 0 0 0 .129-2.504l-.13-.144z"
      />
      <path
        fill={color}
        d="m6.504 16.375.114.006a1.126 1.126 0 0 1 0 2.238l-.114.006h-.006a1.125 1.125 0 0 1 0-2.25zm1.872.877v-.004a1.125 1.125 0 0 1 2.25 0v.004a1.125 1.125 0 0 1-2.25 0m-1.623-3.877.115.006a1.125 1.125 0 0 1 0 2.238l-.115.006h-.005a1.125 1.125 0 0 1 0-2.25zm9.372-3.872v-.005a1.125 1.125 0 0 1 2.25 0v.005a1.126 1.126 0 0 1-2.25 0m-1.622-3.879.114.006a1.126 1.126 0 0 1 0 2.239l-.114.005h-.006a1.125 1.125 0 0 1 0-2.25zm1.872.88v-.006a1.125 1.125 0 0 1 2.25 0v.005a1.126 1.126 0 0 1-2.25 0Z"
      />
    </svg>
  );
}
